import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const inputVariants = cva(
  'flex h-10 w-full rounded-md border border-border bg-card px-3 py-2 text-base md:text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground/70 transition-shadow duration-150 ease-out focus-visible:outline-none focus-visible:border-[hsl(var(--ring))] focus-visible:shadow-glow-brand disabled:cursor-not-allowed disabled:opacity-60',
  {
    variants: {
      variant: {
        default: '',
        error:
          'border-[hsl(var(--error))] focus-visible:border-[hsl(var(--error))] focus-visible:shadow-[0_0_0_3px_hsl(var(--error)/0.25)]',
        success:
          'border-[hsl(var(--success))] focus-visible:border-[hsl(var(--success))] focus-visible:shadow-[0_0_0_3px_hsl(var(--success)/0.25)]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface InputProps
  extends React.ComponentProps<'input'>,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(inputVariants({ variant }), className)}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
